"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _isNativeReflectConstruct2 = _interopRequireDefault(require("@babel/runtime/helpers/isNativeReflectConstruct"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _configProvider = _interopRequireDefault(require("antd/lib/config-provider"));
var _locale = _interopRequireDefault(require("../locale"));
function _callSuper(t, o, e) {
  return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, (0, _isNativeReflectConstruct2["default"])() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function withLocaleProvider(OriginComponent) {
  var WrapperComponent = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WrapperComponent, _React$Component);
    function WrapperComponent() {
      (0, _classCallCheck2["default"])(this, WrapperComponent);
      return _callSuper(this, WrapperComponent, arguments);
    }
    (0, _createClass2["default"])(WrapperComponent, [{
      key: "render",
      value: function render() {
        // eslint-disable-next-line
        var _a = this.props,
          forwardedRef = _a.forwardedRef,
          rest = __rest(_a, ["forwardedRef"]);
        if (isSimpleFunctionComponent(OriginComponent)) {
          forwardedRef = null;
        }
        return /*#__PURE__*/_react["default"].createElement(_configProvider["default"], {
          locale: _locale["default"].get()
        }, /*#__PURE__*/_react["default"].createElement(OriginComponent, (0, _extends2["default"])({}, rest, {
          ref: forwardedRef
        })));
      }
    }]);
    return WrapperComponent;
  }(_react["default"].Component);
  var ForwardRefComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WrapperComponent, (0, _extends2["default"])({
      forwardedRef: ref
    }, props));
  });
  ForwardRefComponent.displayName = "withLocaleProvider".concat(OriginComponent.displayName || OriginComponent.name);
  return ForwardRefComponent;
}
// quote from https://github.com/facebook/react/blob/master/packages/react-reconciler/src/ReactFiber.js
function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}
function isSimpleFunctionComponent(type) {
  return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
}
var _default = exports["default"] = withLocaleProvider;